import {TaskField, TaskFieldRequiredState} from '../../../../../../../constants/tasks';

export const allRequiredFieldsHaveInitialValues = (
    formattedFormFields,
    initialValues
) => formattedFormFields
    .filter((field) => field.required === TaskFieldRequiredState.REQUIRED)
    .map(({id, type}) => {
      if (type === TaskField.MULTI_SELECT) {
        return initialValues[id]?.length;
      }

      return initialValues[id];
    })
    .every((value) => value);
